var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sv-loader"},[_c('Lottie',{attrs:{"options":_vm.defaultOptions,"height":400,"width":400},on:{"animCreated":_vm.handleAnimation}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }